import * as h2Api from '../h2Api'

export const FIND_MATCHING_ACCOUNTS = 'COMBINE_FIND_MATCHING_ACCOUNTS'
export const COMBINE_ACCOUNTS_BY_AUTH = 'COMBINE_ACCOUNTS_BY_AUTH'
export const COMBINE_ACCOUNTS_BY_SELECTION = 'COMBINE_ACCOUNTS_BY_SELECTION'
export const SKIP_COMBINE = 'COMBINE_ACCOUNTS_SKIP'

export const skipCombination = () => dispatch => {
  return dispatch(h2Api.post('/api/v2/auth/combine/skip', null)({ type: SKIP_COMBINE }))
}

export const findMatchingAccounts = () => dispatch => {
  return dispatch(
    h2Api.get('/api/v2/auth/combine/matches')({
      type: FIND_MATCHING_ACCOUNTS
    })
  )
}

export const combineAccountsBySelection = selection => dispatch => {
  return dispatch(
    h2Api.post(
      '/api/v2/auth/combine/choose',
      selection
    )({
      type: COMBINE_ACCOUNTS_BY_AUTH,
      error: 'Account combination failed'
    })
  )
}

export const combineAccountsByAuth = form => dispatch => {
  return dispatch(
    h2Api.post(
      '/api/v2/auth/combine/auth',
      form
    )({
      type: COMBINE_ACCOUNTS_BY_AUTH,
      error: 'Invalid Username or Password'
    })
  )
}
